import React from "react";
import bannerBg from "../assets/images/banner.png";
import banner2Bg from "../assets/images/banner2.png";
import banner3Bg from "../assets/images/banner3.png";
import AwesomeSwiper from "react-awesome-swiper";
//this config is same as idangrous swiper
const config = {
  loop: true,
  direction: "vertical",
  allowTouchMove: false,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },
  slidesPerView: 1,
  // Disable preloading of all images
  // Enable lazy loading
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    bulletElement: "li",
    hideOnClick: false,
    clickable: false,
  },
  on: {
    slideChange: function () {
      // console.log(this.activeIndex);
    },
  },
};
export default function Header() {
  return (
    <AwesomeSwiper config={config} className="your-classname h-screen">
      <div className="relative z-20 text-white h-full flex justify-center items-end">
        <div className="w-full md:w-5/12 py-16 text-center">
          <h2 className="opacity-70 font-light text-xl tracking-wider">
          DAZZLING . AUTHENTIC . AFRICAN
          </h2>
          <h1 className="text-5xl  md:text-6xl my-8">CRAFT HUB</h1>
          <button className="bg-primary px-6 py-3 rounded-md text-lg">
            Click to explore
          </button>
          <div className="flex justify-center mt-10">
            <svg
              width="39"
              height="75"
              viewBox="0 0 39 75"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.5">
                <path
                  d="M10.1243 11.4955L19.3023 20.9654L28.7723 11.7874L32.4727 13.7106L19.2147 26.5598L6.36555 13.3019L10.1243 11.4955Z"
                  fill="#F8F8F8"
                />
              </g>
              <g opacity="0.5">
                <path
                  d="M9.732 29.6334L18.91 39.1034L28.3799 29.9254L32.0803 31.8485L18.8224 44.6977L5.97322 31.4398L9.732 29.6334Z"
                  fill="#F8F8F8"
                />
              </g>
              <g opacity="0.5">
                <path
                  d="M10.1243 47.7713L19.3023 57.2413L28.7723 48.0633L32.4727 49.9865L19.2147 62.8357L6.36555 49.5777L10.1243 47.7713Z"
                  fill="#F8F8F8"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>

      <div className="swiper-wrapper">
        <div className="swiper-slide bg-cover bg-no-repeat  relative">
          <div className="bg-black absolute top-0 left-0 h-full w-full bg-opacity-70 z-20"></div>

          <img src={bannerBg} className="w-full h-full absolute z-10" alt="" />
        </div>
        <div className="swiper-slide bg-cover bg-no-repeat relative">
          <div className="bg-black absolute top-0 left-0 h-full w-full bg-opacity-70 z-20"></div>

          <img src={banner2Bg} className="w-full h-full absolute z-10" alt="" />
        </div>
        <div className="swiper-slide bg-cover bg-no-repeat relative">
          <div className="bg-black absolute top-0 left-0 h-full w-full bg-opacity-70 z-20"></div>

          <img src={banner3Bg} className="w-full h-full absolute z-10" alt="" />
        </div>
      </div>
    </AwesomeSwiper>
  );
}
